'use client';
import React from 'react';
import Header from '@/components/Header';
import Footer from '@/components/Footer';

export default function AboutPage() {
  return (
    <div>
      <Header />
      {/* Hero */}
      <div style={{ background: 'linear-gradient(135deg, #001a4d 0%, #0057b8 60%, #00b4d8 100%)', padding: '80px 16px', color: '#fff', textAlign: 'center' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto' }}>
          <div style={{ display: 'inline-block', background: 'rgba(255,255,255,0.15)', border: '1px solid rgba(255,255,255,0.3)', borderRadius: 999, padding: '6px 20px', fontSize: 13, fontWeight: 600, marginBottom: 20 }}>Est. 2012</div>
          <h1 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 900, fontSize: 'clamp(2rem, 5vw, 3.5rem)', marginBottom: 16 }}>About Printmob Hub</h1>
          <p style={{ color: 'rgba(255,255,255,0.8)', fontSize: 17, maxWidth: 640, margin: '0 auto 40px' }}>
            Delivering cutting-edge printing solutions with a commitment to quality, innovation, and customer satisfaction since 2012.
          </p>
          <div style={{ display: 'flex', justifyContent: 'center', gap: 0, flexWrap: 'wrap' }}>
            {[['12+', 'Years of Excellence'], ['10K+', 'Happy Customers'], ['500+', 'Products'], ['5★', 'Customer Rating']]?.map(([num, label], i) => (
              <div key={label} style={{ padding: '20px 40px', borderRight: i < 3 ? '1px solid rgba(255,255,255,0.2)' : 'none', textAlign: 'center' }}>
                <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 900, fontSize: 32 }}>{num}</div>
                <div style={{ color: 'rgba(255,255,255,0.7)', fontSize: 14 }}>{label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>
      {/* Vision & Mission */}
      <section style={{ padding: '64px 16px', background: '#f0f4ff' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto', display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', gap: 32 }}>
          {/* Vision */}
          <div className="vision-card">
            <div style={{ position: 'absolute', top: 0, right: 0, width: 200, height: 200, background: 'rgba(255,255,255,0.03)', borderRadius: '50%', transform: 'translate(50%, -50%)' }} />
            <div style={{ width: 56, height: 56, borderRadius: 16, background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, marginBottom: 20 }}>🎯</div>
            <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: '1.6rem', marginBottom: 16 }}>Our Vision</h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, marginBottom: 24 }}>
              Printmob Hub is committed to satisfy its clients by providing cost-effective and efficient solutions, using innovative processes, skilled manpower, latest technology, and world class facilities — with a commitment to continuous improvement.
            </p>
            <div style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 12, padding: 20 }}>
              <div style={{ fontWeight: 700, marginBottom: 12, fontSize: 14 }}>Quality Objectives</div>
              {[
                'Customer satisfaction by delivering service as per requirements',
                'Continuous adoption of new technology and better facilities',
                'Continuous improvement of processes',
                'Continuous development of human resource',
              ]?.map((obj, i) => (
                <div key={i} style={{ display: 'flex', gap: 12, marginBottom: 8, alignItems: 'flex-start' }}>
                  <span style={{ width: 24, height: 24, borderRadius: '50%', background: 'rgba(255,255,255,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 12, fontWeight: 700, flexShrink: 0 }}>{i + 1}</span>
                  <span style={{ color: 'rgba(255,255,255,0.8)', fontSize: 13, lineHeight: 1.5 }}>{obj}</span>
                </div>
              ))}
            </div>
          </div>

          {/* Mission */}
          <div className="mission-card">
            <div style={{ position: 'absolute', top: 0, right: 0, width: 200, height: 200, background: 'rgba(255,255,255,0.03)', borderRadius: '50%', transform: 'translate(50%, -50%)' }} />
            <div style={{ width: 56, height: 56, borderRadius: 16, background: 'rgba(255,255,255,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 28, marginBottom: 20 }}>🚀</div>
            <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 800, fontSize: '1.6rem', marginBottom: 16 }}>Our Mission</h2>
            <p style={{ color: 'rgba(255,255,255,0.8)', lineHeight: 1.8, marginBottom: 24 }}>
              Printmob Hub will provide highest quality solutions based upon technology, in the most cost-effective manner, to facilitate our customers. For this, we collaborate with the world&apos;s best principals and spread latest cutting-edge technology at the local level.
            </p>
            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 12 }}>
              {[['🌐', 'World-class', 'Partnerships'], ['💡', 'Cutting-edge', 'Technology'], ['💰', 'Cost-effective', 'Solutions'], ['🤝', 'Customer', 'Focused']]?.map(([icon, line1, line2]) => (
                <div key={line1} style={{ background: 'rgba(255,255,255,0.1)', borderRadius: 10, padding: 12, textAlign: 'center' }}>
                  <div style={{ fontSize: 20, marginBottom: 4 }}>{icon}</div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.9)', fontWeight: 600 }}>{line1}</div>
                  <div style={{ fontSize: 12, color: 'rgba(255,255,255,0.7)' }}>{line2}</div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>
      {/* MD Message */}
      <section style={{ padding: '64px 16px', background: '#fff' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div style={{ color: '#00b4d8', fontWeight: 600, fontSize: 12, letterSpacing: '0.1em', textTransform: 'uppercase' }}>Leadership</div>
            <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 900, fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', color: '#1f2937', marginTop: 8 }}>Founder&apos;s Message</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))', gap: 32, alignItems: 'start' }}>
            <div style={{ background: '#f0f4ff', borderRadius: 20, padding: 32, textAlign: 'center' }}>
              <div style={{ width: 80, height: 80, borderRadius: '50%', background: '#0057b8', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 900, fontSize: 28, margin: '0 auto 16px', fontFamily: 'Syne, sans-serif' }}>D</div>
              <div style={{ fontWeight: 700, fontSize: 18, color: '#1f2937', marginBottom: 4 }}>Dave Johnson</div>
              <div style={{ color: '#6b7280', fontSize: 14, marginBottom: 16 }}>Founder & CEO</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8, textAlign: 'left' }}>
                {['🎓 B.S. Computer Science — UT Dallas', '💼 Ex-HP Inc. — Senior Sales Manager', '🏆 12+ Years in Printing Industry']?.map(item => (
                  <div key={item} style={{ background: '#fff', borderRadius: 8, padding: '8px 12px', fontSize: 13, color: '#374151' }}>{item}</div>
                ))}
              </div>
              <div style={{ marginTop: 16, background: '#0057b8', color: '#fff', borderRadius: 8, padding: '6px 16px', fontSize: 13, fontWeight: 600, display: 'inline-block' }}>12+ Years Experience</div>
            </div>
            <div style={{ background: '#f9fafb', borderRadius: 20, padding: 32 }}>
              <div style={{ fontSize: 48, color: '#0057b8', fontFamily: 'Georgia, serif', lineHeight: 1, marginBottom: 16 }}>&ldquo;</div>
              <p style={{ color: '#374151', lineHeight: 1.8, marginBottom: 16 }}>
                Dave Johnson founded Printmob Hub in <strong>2012</strong>, with a vision to bring forth the latest cutting-edge printing technology to the Dallas-Fort Worth area and beyond.
              </p>
              <p style={{ color: '#374151', lineHeight: 1.8, marginBottom: 16 }}>
                His customer-centric focus and dynamic leadership has moved the organization towards new horizons, serving thousands of satisfied customers across the United States.
              </p>
              <p style={{ color: '#374151', lineHeight: 1.8, marginBottom: 24 }}>
                Prior to founding Printmob Hub, Dave worked with <strong>HP Inc.</strong> as a Senior Sales Manager. He holds a B.S. in Computer Science from <strong>UT Dallas</strong>.
              </p>
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 48, height: 48, borderRadius: '50%', background: '#0057b8', color: '#fff', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 18 }}>D</div>
                <div>
                  <div style={{ fontWeight: 700, color: '#1f2937' }}>Dave Johnson</div>
                  <div style={{ fontSize: 13, color: '#6b7280' }}>Founder & CEO, Printmob Hub</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* Core Values */}
      <section style={{ padding: '64px 16px', background: '#f0f4ff' }}>
        <div style={{ maxWidth: 1280, margin: '0 auto' }}>
          <div style={{ textAlign: 'center', marginBottom: 48 }}>
            <div style={{ color: '#00b4d8', fontWeight: 600, fontSize: 12, letterSpacing: '0.1em', textTransform: 'uppercase' }}>What Drives Us</div>
            <h2 style={{ fontFamily: 'Syne, sans-serif', fontWeight: 900, fontSize: 'clamp(1.8rem, 3vw, 2.5rem)', color: '#1f2937', marginTop: 8 }}>Our Core Values</h2>
          </div>
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 24 }}>
            {[
              { icon: '🏆', title: 'Quality First', desc: 'Uncompromising standards in every solution' },
              { icon: '🤝', title: 'Customer Trust', desc: 'Building lasting relationships through reliability' },
              { icon: '💡', title: 'Innovation', desc: 'Continuously adopting cutting-edge technology' },
              { icon: '⚡', title: 'Speed & Efficiency', desc: 'Fast, effective solutions that save time and cost' },
              { icon: '📈', title: 'Growth Mindset', desc: 'Committed to continuous improvement every day' },
            ]?.map(item => (
              <div key={item?.title} style={{ background: '#fff', borderRadius: 16, padding: 24, textAlign: 'center', border: '1px solid #e2e8f4', transition: 'transform 0.2s, box-shadow 0.2s' }}
                onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-4px)'; e.currentTarget.style.boxShadow = '0 12px 32px rgba(0,87,184,0.1)'; }}
                onMouseLeave={e => { e.currentTarget.style.transform = 'translateY(0)'; e.currentTarget.style.boxShadow = 'none'; }}>
                <div style={{ fontSize: 36, marginBottom: 12 }}>{item?.icon}</div>
                <div style={{ fontFamily: 'Syne, sans-serif', fontWeight: 700, fontSize: 15, color: '#1f2937', marginBottom: 8 }}>{item?.title}</div>
                <div style={{ fontSize: 13, color: '#6b7280', lineHeight: 1.6 }}>{item?.desc}</div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
